import api from "../index";

export const UpgradePlanListApi = () => api.post("get-employee-upgrade-plans");
export const AddUpgradePlanApi = (data, header) => api.post("create-employee-upgrade-plan", data, header);
export const EditUpgradePlanApi = (data, header) => api.post("update-employee-upgrade-plan", data, header);
export const DeleteUpgradePlanApi = (data) => api.post("delete-employee-upgrade-plan", data);
export const ChangeUpgradePlanStatusApi = (data) => api.post("change-employee-upgrade-plan-status",data);
